<template>
  <div ref="toast" data-bs-dismiss="toast" aria-label="Close" class="toast align-items-center"
       :class="messageToast.type" role="alert" aria-live="assertive"
       aria-atomic="true">
    <div class="toast-body">
      {{ messageToast.msg }}
    </div>
    <button type="button" class="btn">
      <span class="ic-cross"></span>
    </button>

  </div>
</template>

<script>
import UseMessages from "@/composables/UseMessages";
import {Toast} from 'bootstrap'

export default {
  name: "Messages",
  setup() {
    return {
      ...UseMessages()
    }
  },
  mounted() {
    this.toast = new Toast(this.$refs.toast, {})
  },
  data() {
    return {
      messageToast: {
        msg: '',
        type: ''
      },
      toast: undefined
    }
  },
  watch: {
    messagesList: {
      handler(val) {
        this.messageToast = val[val.length - 1]
        this.$nextTick(() => {
          this.toast.show()
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  top: 1em;
  left: 160px;
  max-width: calc(100vw - 1em);
  color: var(--common-background-frame);
  display: flex;
  justify-content: space-between;
  z-index: 1061;
  border-radius: 20px;
  padding: 0 1em;
  cursor: pointer;

  &:hover button span {
    color: var(--common-background-shape);
  }

  button {
    span {
      color: var(--common-background-frame);
    }

    padding: 0 5px;
  }

  &.warning {
    background-color: #ffb004;
  }

  &.error {
    background-color: #dc5454;
  }

  &.success {
    background-color: #8fb665;
  }
}

@media (max-width: 1200px) {
  .toast {
    left: 130px;
  }
}

@media (max-width: 800px) {
  .toast {
    left: .5em;
  }
}
</style>
